/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateServiceCenterRequest { 
    id: string;
    name: string;
    address?: string | null;
    contactInfo?: string | null;
}

